import { Time } from "@angular/common";
import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { Validators } from "@angular/forms";
import { IArenaDto } from "@models/arena/dtos/arena-dto";
import { ModalSpaceDto } from "@models/arena/dtos/modal-space-dto";
import { PageRequest } from "@models/pagination/page-request";
import { ISportDto } from "@models/sport-dto";
import { DateTimeEnum } from "@shared/components/date-time-picker/date-time-picker.component";
import { NewDropdownComponent } from "@shared/components/dropdown/new-dropdown.component";
import { ArenaService } from "@shared/services/arena.service";
import { BaseComponent } from "src/app/core/utilities/base-component/base-component";


@Component({
  selector: 'sigecom-modal-arena',
  templateUrl: './modal-arena.component.html'
})
export class ModalArenaComponent extends BaseComponent implements OnInit {

  @ViewChild('space', { static: true })  space!: NewDropdownComponent<ISportDto>;

  #arenaService = inject(ArenaService);


  competitonsLocal : IArenaDto[] = [];
  spaces: ModalSpaceDto[] = [];
  DateTimeEnum = DateTimeEnum;

  modalArenaForm = this.fb.group({
    competitionLocal: this.fb.control<string | undefined>(undefined,[
      Validators.required
    ]),
    space: this.fb.control<string | undefined>(undefined,[
      Validators.required
    ]),
    competitonDate : this.fb.control<Date | undefined>(undefined,[
      Validators.required
    ]),
    competitonHour:this.fb.control<Time | undefined>(undefined,[
      Validators.required
    ]),
  })

  ngOnInit(): void {
    this.#getArenas();
   }

   OnsubmitModalArenaForm(){
      console.log(this.modalArenaForm.value)
      this.modalArenaForm.reset();
   }
  #getArenas(){
   this.#arenaService.findArenas$({},PageRequest.default()).subscribe({
    next: (res) => {
      this.competitonsLocal = res.content ?? [];
      this.space.setDisabledState(true);
    },
    error: (err) => this.messageErrorResolver.resolveMessage(err)
   })
  }
  getSpaces(event: Event){
    this.space.setDisabledState(event === null);
    const areNrId : number = Number(event)

    const competitonLocal = this.competitonsLocal.find((local) => {
      return local.areNrId === areNrId
    })
    this.spaces = competitonLocal?.espacoDtos!
  }
}
